import React from "react";
import { Card, CardHeader, CardBody, CardFooter } from "reactstrap";
import { Markdown } from "components/Markdown";
import { Collector } from "./Collector";
import "./exercise.scss";

function Exercise(props) {
  const { exercise, answer } = props;

  return (
    <div className="exercise">
      <Card className="problem">
        <CardHeader className="question-card-header">
          <Markdown>{exercise.question}</Markdown>
        </CardHeader>
        <CardFooter>
          <div className="question-actions">
            <a
              href={`mailto:ed@solvefaction.com?subject=Problem with exercise ${exercise.id}`}
              onClick={() => {
                window.analytics.track("exercise.reportProblem", {
                  id: exercise.id
                });
              }}
            >
              <button className="question-action-element btn-icon">
                <img src={"/img/icons/warning.svg"} alt={"Warning Sign"} />
                Report a problem
              </button>
            </a>
            <div className="question-action-element pull-right">
              Difficulty: Unknown
            </div>
          </div>
        </CardFooter>
      </Card>
      <Card className="collector-container">
        <CardBody>
          <Collector
            key={exercise.id}
            exercise={exercise}
            onChange={props.onAnswer}
            selectedAnswer={answer}
          />
        </CardBody>
      </Card>
    </div>
  );
}

export { Exercise };
